import { Alert, Button } from "@cvpartner/design-system";
import type React from "react";
import { I18n } from "@/util/translations.ts";
import { KeepMeSignedInCheckbox } from "./Login.tsx";
import { Form } from "./shared/Form.tsx";
import { CardContent } from "./shared/LoginCard.tsx";
import { LoginButtonWrapper, Wrapper } from "./shared/Modern.tsx";

export const TimeoutSSO: React.FC = () => (
  <Wrapper
    heading={I18n.t("signin.header_title")}
    alert={
      <Alert type="warning" title={I18n.t("signin.alert.signout_inactivity")} />
    }
  >
    <Form action="/login/timeout_sso">
      <CardContent>
        <KeepMeSignedInCheckbox />
        <LoginButtonWrapper center={false}>
          <Button type="submit" hierarchy="primary">
            {I18n.t("signin.signin_button")}
          </Button>
        </LoginButtonWrapper>
      </CardContent>
    </Form>
  </Wrapper>
);
